import { render, staticRenderFns } from "./FeedEventPostComment.vue?vue&type=template&id=4315ec7f&scoped=true"
import script from "./FeedEventPostComment.vue?vue&type=script&lang=js"
export * from "./FeedEventPostComment.vue?vue&type=script&lang=js"
import style0 from "./FeedEventPostComment.vue?vue&type=style&index=0&id=4315ec7f&prod&scoped=true&lang=css"
import style1 from "./FeedEventPostComment.vue?vue&type=style&index=1&id=4315ec7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4315ec7f",
  null
  
)

export default component.exports